import React from 'react'
import { Link } from 'react-router-dom'
import { LatestBooksType } from '../../../models/latest-books-model'

const BooksCardArticle = (props: { article: LatestBooksType[] }) => {
  const article = props.article
  return (
    <div className="col-sm">
      <div className="feed-single">
        <img src={article[0]?.imageUrl} alt={article[0]?.name} loading="lazy" />
        <div className="feed-content">
          <Link to='/education/books'><h5>Books</h5></Link>
          <ul>
            {
              (article.length > 1) ? (
                article?.map((item, index) => {
                  return <li key={index}>
                    <Link to={"/products/" + item.nodeName} dangerouslySetInnerHTML={{ __html: item.name }}></Link>
                  </li>
                })

              ) : (
                <li>
                  <Link to={article[0]?.nodeName} dangerouslySetInnerHTML={{ __html: article[0]?.name }}></Link>
                  {/* <p dangerouslySetInnerHTML={{__html: article[0]?.articleTeaserText}}></p> */}
                </li>
              )
            }
          </ul>
        </div>
        <div className="Newsrelink"></div>
      </div>
    </div>
  )
}

export default BooksCardArticle
